/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VpnConfigurationDto } from '../../models/vpn-configuration-dto';

export interface GetConfigurations$Params {
}

export function getConfigurations(http: HttpClient, rootUrl: string, params?: GetConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VpnConfigurationDto>>> {
  const rb = new RequestBuilder(rootUrl, getConfigurations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VpnConfigurationDto>>;
    })
  );
}

getConfigurations.PATH = '/vpn/configurations';
